const MAX_SHIFT = 4;
const STIFFNESS = 0.09;
const DAMPING = 0.74;
const BREAKPOINT = 1024;

function initBtnMove() {
  const buttons = document.querySelectorAll('.btn-move:not([data-btn-move-init])');

  buttons.forEach((btn) => {
    btn.dataset.btnMoveInit = '1';

    let rafId = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    let velX = 0;
    let velY = 0;
    let isHovered = false;

    function tick() {
      velX = (velX + (targetX - currentX) * STIFFNESS) * DAMPING;
      velY = (velY + (targetY - currentY) * STIFFNESS) * DAMPING;

      currentX += velX;
      currentY += velY;

      btn.style.transform = `translate(${currentX.toFixed(3)}px, ${currentY.toFixed(3)}px)`;

      const settled =
        !isHovered &&
        Math.abs(velX) < 0.01 &&
        Math.abs(velY) < 0.01 &&
        Math.abs(currentX - targetX) < 0.05 &&
        Math.abs(currentY - targetY) < 0.05;

      if (settled) {
        currentX = 0;
        currentY = 0;
        velX = 0;
        velY = 0;
        btn.style.transform = 'translate(0px, 0px)';
        rafId = null;
      } else {
        rafId = requestAnimationFrame(tick);
      }
    }

    function startLoop() {
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    btn.addEventListener('mouseenter', () => {
      if (window.innerWidth <= BREAKPOINT) return;
      isHovered = true;
    });

    btn.addEventListener('mousemove', (e) => {
      if (window.innerWidth <= BREAKPOINT) return;

      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      targetX = ((e.clientX - cx) / (rect.width / 2)) * MAX_SHIFT;
      targetY = ((e.clientY - cy) / (rect.height / 2)) * MAX_SHIFT;

      startLoop();
    });

    btn.addEventListener('mouseleave', () => {
      isHovered = false;
      targetX = 0;
      targetY = 0;
      startLoop();
    });
  });
}

window.initBtnMove = initBtnMove;
initBtnMove();
